
const identity_ = require('lodash/identity')
const merge_ = require('lodash/merge')
const pull_ = require('lodash/pull')

const retry = (Raven, ravenFunction) => (...args) => {
  try {
    Raven[ravenFunction](...args)
  } catch (e) {
    try {
      Raven[ravenFunction](`Failed on ${ravenFunction}. Got exception: ${e.name} - ${e.message}`, {
        extra: {
          'original-error': JSON.stringify(args)
        }
      })
    } catch (e) {
      // well... we really have nothing to do here :(
    }
  }
}

module.exports = (Raven) => {
  const callbacks = []

  Raven.setDataCallback((data, originalCallback = identity_) => {
    callbacks.forEach(cb => merge_(data.extra, cb()))
    return originalCallback(data)
  })

  return {
    addDataCallback: cb => {
      callbacks.push(cb)
      return () => pull_(callbacks, cb)
    },
    captureBreadcrumb: (...args) => Raven.captureBreadcrumb(...args),
    captureException: (...args) => retry(Raven, 'captureException')(...args),
    captureMessage: (...args) => retry(Raven, 'captureMessage')(...args)
  }
}



// WEBPACK FOOTER //
// ./raven/ravenProxy.js